import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/sif/izvajalec";

export const fetchOperators = createAsyncThunk(
  "operators/list",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(baseUrl);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchOperatorsPage = createAsyncThunk(
  "operators/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        null,
        page,
        filter,
        sort
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchOperatorBySifra = createAsyncThunk(
  "operators/byCode",
  async (sifra, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(`${baseUrl}/${sifra}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const operatorSlice = createSlice({
  name: "operator",
  initialState: {
    list: [],
    page: null,

    details: {},
    error: null,
    isLoading: false,

    byId: {},
    isLoadingById: {},
    errorById: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOperators.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;

        action.payload.forEach((item) => {
          state.byId[item.sifra] = item;
        });
      })
      .addCase(fetchOperators.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchOperators.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchOperatorsPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(fetchOperatorsPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchOperatorsPage.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchOperatorBySifra.pending, (state, action) => {
        const sifra = action.meta.arg;

        state.isLoading = true;
        if (sifra) {
          state.errorById[sifra] = null;
          state.isLoadingById[sifra] = true;
        } else {
          state.isLoading = true;
          state.error = null;
          state.details = null;
        }
      })
      .addCase(fetchOperatorBySifra.fulfilled, (state, action) => {
        const item = action.payload;
        if (item?.sifra) {
          state.errorById[item.sifra] = null;
          state.byId[item.sifra] = item;
          state.isLoadingById[item.sifra] = false;
        }
        state.error = null;
        state.details = item;
        state.isLoading = false;
      })
      .addCase(fetchOperatorBySifra.rejected, (state, action) => {
        const sifra = action.meta.arg;
        if (sifra) {
          state.errorById[sifra] = action.payload;
          state.isLoadingById[sifra] = false;
        } else {
          state.error = action.payload;
          state.isLoading = false;
        }
      });
  },
});

export default operatorSlice.reducer;

export const SHEEP_GOAT_EVENT_OPERATOR_LIST = createSelector(
  (state) => state.operator,
  ({ list }) =>
    list.filter(
      ({ sifra, veljaZaKoze, veljaZaOvce }) =>
        veljaZaKoze && veljaZaOvce && !!sifra
    )
);
